module.exports = __webpack_public_path__ + "img/29.3c032afe.png";